import { useRetailerStatus } from "@faire/deprecated-retailer-visitor-shared/hooks/retailer/useRetailerStatus";
import { useR2BAwardStore } from "@faire/deprecated-retailer-visitor-shared/stores/domain/useR2BAwardStore";
import { Decorative } from "@faire/design-tokens";
import { trackR2BReferralsEntrySearchDropdown } from "@faire/web-api--source/events/r2BReferrals/actionCategoryOther/entrySearchDropdown";
import userBrandReferrals from "@faire/web-api--source/routes/www/user/brand-referrals";
import { HorizontalLine } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { Link } from "@faire/web/ui/LinkAnchor";
import styled from "styled-components";

export const R2MSection = ({
  onMouseOver,
  onMouseLeave,
  onClick,
}: {
  onClick: () => void;
  onMouseOver: () => void;
  onMouseLeave: () => void;
}) => {
  const { showR2B } = useRetailerStatus();
  const { r2bAdvertisedRetailerAwardFormatted } = useR2BAwardStore();

  if (!showR2B) {
    return <Spacer height="2x" />;
  }

  return (
    <>
      <R2MDivider>
        <HorizontalLine />
      </R2MDivider>
      <Link
        to={userBrandReferrals()}
        onClick={() => {
          onClick();
          trackR2BReferralsEntrySearchDropdown();
        }}
      >
        <R2MPromoText onMouseOver={onMouseOver} onMouseLeave={onMouseLeave}>
          <Typography>
            <StrictLocalMsg
              id="v+PG/c"
              defaultMessage="Not finding what you need?"
              description={{
                text: "Message at the end of a search list",
              }}
            />
          </Typography>
          <Spacer size="1x" />
          <Typography
            color={Decorative.shade.orange}
            variant="paragraphSansMedium"
          >
            <StrictLocalMsg
              id="F/Uxzn"
              defaultMessage="Refer brands and earn up to {amountMoney}"
              description={{
                text: "Call to action that links to brand referral page",
              }}
              values={{
                amountMoney: r2bAdvertisedRetailerAwardFormatted,
              }}
            />
          </Typography>
        </R2MPromoText>
      </Link>
    </>
  );
};

const R2MPromoText = styled.div`
  text-align: center;
  padding: ${getSpacing("2x")} !important;

  &:hover {
    background-color: rgba(234, 234, 234, 0.5);
  }
`;

const R2MDivider = styled.div`
  padding: 0 8px;
`;
